import { Paper, PaperProps, styled } from "@mui/material";
import React from "react";
import { pxToRem } from "../../../utils/fontSizeUtility";

export const SuggestionsPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  rowGap: pxToRem(1),
  columnGap: pxToRem(8),
  display: "flex",
  flexFlow: "wrap",
  justifyContent: "flex-end",
  marginLeft: "auto",
  msOverflowStyle: "none",
  overflowY: "hidden",
  "::-webkit-scrollbar": {
    display: "none",
  },
  height: pxToRem(47),
  minHeight: pxToRem(47),
  maxHeight: pxToRem(47),

  marginTop: pxToRem(4),
  alignContent: "flex-start",
})) as React.ComponentType<PaperProps>;
